import * as React from 'react';
/**
 *
 * Original name: Medium
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=22733%3A2868
 *
 */
export const MediumExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.589 12.328c0 2.666-2.147 4.827-4.794 4.827C5.147 17.155 3 14.993 3 12.327 3 9.663 5.147 7.5 7.795 7.5s4.794 2.161 4.794 4.828Zm5.26 0c0 2.51-1.073 4.545-2.397 4.545-1.324 0-2.398-2.036-2.398-4.545 0-2.51 1.073-4.545 2.397-4.545 1.324 0 2.398 2.035 2.398 4.545Zm1.308 4.071c.466 0 .843-1.823.843-4.071 0-2.249-.378-4.072-.843-4.072-.466 0-.843 1.823-.843 4.072 0 2.248.377 4.071.843 4.071Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
